import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { UserContextService } from '../../services/user-context-service/user-context.service';

@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  imports: [CommonModule, TranslateModule, RouterModule, FormsModule, ReactiveFormsModule],
})
export class ConsentComponent implements OnInit {
  consentForm: FormGroup;
  isDisableable: boolean = false;

  constructor(
    private readonly userContextService: UserContextService,
    private readonly router: Router,
    private readonly appConfigService: AppConfigService
  ) {}

  ngOnInit(): void {
    this.consentForm = new FormGroup({
      hasGivenConsent: new FormControl(false, [Validators.requiredTrue]),
    });
    this.isDisableable = this.appConfigService.configData?.rspButtonShouldBeDisabled ?? true;
  }

  giveConsent(): void {
    if (this.consentForm.invalid) {
      this.consentForm.markAllAsTouched();
      return;
    }
    this.userContextService
      .giveConsent(this.userContextService.loggedInUser?.id.toString())
      .subscribe(() => this.router.navigate(['/initial-information']));
  }
}
